import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../config/config';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { ButtonTriggerEvent } from '../../../common/components';
import { BaseComponent } from '../../../common/components/base.component';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { FacebookPost } from '../../../common/components/facebook.post/facebook.post';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { isNullOrUndefined } from '../../../common/extensions';
import { popupCenter } from '../../../common/extensions/browser/browser.extensions';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { ModalService } from '../../../common/services/modal.service';
import { HubEvent } from '../../../models/hub/hub.event';
import { ConfigService } from '../../../services/config.service';
import { EventTimeService } from '../../../services/event.time.service';
import { ImageService } from '../../../services/image.service';
import { ShareService } from '../../../services/share.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import {VisitorCalendarStore, VisitorDataCache} from '../../../stores/visitor.calendar.store';
import ShareDialogParams = facebook.ShareDialogParams;
import AuthResponse = facebook.AuthResponse;
import { constantConfigs } from '../../../common/constants/constant';

@Component({
    selector: 'ig-event-details',
    templateUrl: './visitor.event.details.component.html',
    styleUrls: [
        './visitor.event.details.component.scss',
        '../../../../node_modules/snazzy-info-window/dist/snazzy-info-window.css'
    ],
    encapsulation: ViewEncapsulation.None
})
export class VisitorEventDetailsComponent extends BaseComponent implements OnInit {
    public lat: number = ConfigService.config.google.USCenter.lat;
    public lng: number = ConfigService.config.google.USCenter.lng;
    public mapZoom = 14;
    public events: HubEvent[];
    public event: HubEvent;
    public latLngBounds: any;
    public simpleMenu = true;
    public hubName: string;
    public timeout: any;
    public category: string;
    public isLoading = true;
    public authResponse: AuthResponse;
    public joinedEventIds: string[];
    public actionCommand = new VisitorCalendarActionCommand();
    public eventFeeds: FacebookPost[];
    public eventFeedPaging: { next: string };
    public eventHost;
    public featuresToggle = {
        tripPlanner: false,
        placeCalendar: true,
    };
    public hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
    @ViewChild('loadingSpinner') loadingSpinner: PageSpinnerComponent;
    @ViewChild('loginWithFBBtn') loginWithFBBtn: FacebookLoginButtonComponent;
    @ViewChild('description') description: ElementRef;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private visitorCalendarStore: VisitorCalendarStore,
                private visitorApiService: VisitorApiService,
                private googleMapService: GoogleMapsService,
                public imageService: ImageService,
                private modalService: ModalService) {
        super({activatedRoute});
    }

    public ngOnInit() {
        let {hubName, category, menuType} = this.allRouteParams;
        this.category = category || 'all';
        this.hubName = hubName;
        this.simpleMenu = menuType === 'simple';
        this.eventHost = constantConfigs.facebook.host;
        this.loadEvents();

        this.visitorApiService.getToggles(this.hubName).subscribe(toggle => {
            if (toggle) {
                this.featuresToggle.tripPlanner = isNullOrUndefined(toggle.tripPlanner) ? true : toggle.tripPlanner;
                this.featuresToggle.placeCalendar = isNullOrUndefined(toggle.placeCalendar) ? true : toggle.placeCalendar;
            }
        });
    }

    // public close() {
    //     this.sideBar.close();
    // }

    public jumpFacebook() {
        if (this.event.eventLink && this.event.eventLink !== 'undefined') {
            window.open(this.event.eventLink);
        } else if (this.event.socialName == 'eventbrite') {
            window.open('https://www.eventbrite.com/e/' + this.event.id);
        } else if (this.event.socialName == 'facebook') {
            window.open('https://www.facebook.com/' + this.event.id);
        } else if (this.event.socialName == 'eventful') {
            window.open('http://auckland.eventful.com/events/' + this.event.id);
        }
    }

    public gotoEventCalendar() {
        // if (this.isMobile&&isSafari()) {
        //     setTimeout(() => {
        //         this.actionCommand.isEventCalendar = true;
        //         this.actionCommand.queryCommand.category = 'All';
        //         this.actionCommand.queryCommand.choice = null;
        //         this.actionCommand.queryCommand.isCustom = null;
        //         this.actionCommand.queryCommand.mostAttended = null;
        //         this.actionCommand.queryCommand.feedId = null;
        //         this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        //     });
        // }

        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar,
            {
                hubName: this.hubName
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });

        this.actionCommand.isEventCalendar = true;
        this.actionCommand.queryCommand.category = 'All';
        this.actionCommand.queryCommand.choice = null;
        this.actionCommand.queryCommand.isCustom = null;
        this.actionCommand.queryCommand.mostAttended = null;
        this.actionCommand.queryCommand.feedId = null;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    }

    public gotoPlaceCalendar() {
        // if (this.isMobile&&isSafari()) {
        //     setTimeout(() => {
        //         this.category = 'all';
        //         this.actionCommand.isEventCalendar = false;
        //         this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        //     });
        // }

        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar,
            {
                hubName: this.hubName,
                category: this.category
            }), { skipLocationChange: this.noChangeUrlWhenRedirect })
        ;
        this.category = 'all';
        this.actionCommand.isEventCalendar = false;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    }

    public gotoDetails(id) {
        let {hubName} = this.allRouteParams;
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventDetails,
            {
                hubName,
                eventId: id
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        setTimeout(() => {
            this.loadEvents();
        });
    }

    public showInfoWindow(marker: any) {
        if (!marker._isOpen) {
            marker._openInfoWindow();
        }

        clearTimeout(this.timeout);
    }

    public hideInfoWindow(marker: any) {
        this.timeout = setTimeout(function () {
            marker._closeInfoWindow();
        }, 1500);
    }

    public onSideNavScroll(event) {
        event.stopPropagation();
    }

    public getDirectionToEventAddress() {
        let url = config.eventShare.googleMapGetDirection
            .replace('${address}', encodeURIComponent(this.event.address.address));
        window.open(url, '_blank');
    }

    public shareEventToFacebook() {
        // let href = (window.location.href.indexOf('test/events/5e4d1d23df1890118940d617') >= 0 || window.location.href.indexOf('test/events/5e4d1dc0df1890118940d61d') >= 0) ? this.event.eventLink : window.location.href;
        // href = href.indexOf('test/events/5e4d1d23df1890118940d615') >= 0 ? 'https://imgoingcalendar.com/assets/pages/recognized.categories.html' : href;
        let href = this.event.eventLink || window.location.href;
        let params = <ShareDialogParams>{
            method: 'share',
            href: href,
            quote: (this.event.title || this.event.name) + ' - ' + this.event.description,
            // picture: !!this.event.cover && this.event.cover.source
        };
        FB.ui(params, () => {
        });
    }

    public tweetEvent() {
        let shareLink = config.eventShare.tweet
            .replace('${text}', this.event.name)
            .replace('${url}', encodeURIComponent(window.location.href));
        popupCenter(shareLink);
    }

    public mailEvent() {
        if (this.isMobile) {
            window.open(ShareService.toMailableEvent(this.event, window.location.href));
        } else {
            window.location.href = ShareService.toMailableEvent(this.event, window.location.href);
        }
    }

    public initFacebookStatus() {
        this.authResponse = FacebookLoginButtonComponent.authResponse ? FacebookLoginButtonComponent.authResponse.authResponse : null;

        if (FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
            FB.api(config.facebook.graphApi.events
                    .replace('${userId}', FacebookLoginButtonComponent.authResponse.authResponse.userID),
                {access_token: this.authResponse.accessToken},
                (eventsResponse) => {
                    if (!eventsResponse.error && eventsResponse.data.length > 0) {
                        this.joinedEventIds = eventsResponse.data.map(x => x.id);
                    }
                }
            );

            //this.getFacebookEventFeed();
        }
    }

    public getFacebookEventFeed() {
        if (this.event && this.event.id &&
            FacebookLoginButtonComponent.isUserLoggedWithFacebook &&
            this.event.socialName != 'eventbrite' && this.event.socialName != 'eventful') {
            FB.api(config.facebook.graphApi.eventPosts
                    .replace('${accessToken}', FacebookLoginButtonComponent.userAccessToken)
                    .replace('${eventId}', this.event.id),
                (response) => {
                    this.eventFeedPaging = response.paging;

                    if (!!response.error) {
                        console.error(response.error);
                        return;
                    }

                    this.updateEventFeeds(response.data);
                });
        }
    }

    public getNextFacebookEventFeed(event: ButtonTriggerEvent) {
        FB.api(this.eventFeedPaging.next,
            (response) => {
                event.complete();
                this.eventFeedPaging = response.paging;

                if (!!response.error) {
                    console.error(response.error);
                    return;
                }

                this.updateEventFeeds(this.eventFeeds.concat(response.data));
            });
    }

    private updateEventFeeds(eventFeeds) {
        this.eventFeeds = eventFeeds;
        this.eventFeeds.forEach(x => {
            x.from.link =
                config.facebook.graphApi.profile.replace('${userId}', x.from.id);
            x.from.picture =
                config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
        });
    }

    private getEvents(): Observable<HubEvent[]> {
        let limit = config.searchLimit; // 0 represents no limit, but seems only 9 records can be found if this set to 0
        return this.visitorApiService.getEvents(this.hubName, {page: 1, limit: limit, category: 'All'});
    }

    private loadEvents() {
        this.isLoading = true;
        this.loadingSpinner.show();

        let {eventId} = this.allRouteParams;
        // let allEventsWithCurrent = JSON.parse(localStorage.getItem(localStorageKeys.visitorEvents));
        let allEventsWithCurrent = VisitorDataCache.events;

        let needToLoadEvents = false;
        if (!allEventsWithCurrent) {
            needToLoadEvents = true;
        } else {
            this.event = allEventsWithCurrent.first(x => x._id === eventId);
            if (!this.event) {
                needToLoadEvents = true;
            } else {
                EventTimeService.formatEventTime(allEventsWithCurrent);
                this.setMeta();
            }
        }

        if (needToLoadEvents) {
            this.getEvents().subscribe(data => {
                if (data && data.length) {
                    EventTimeService.formatEventTime(data);
                    this.event = data.first(x => x._id === eventId);
                    if (this.event && this.event.socialName === config.eventbrite) {
                        this.eventHost = constantConfigs.eventbrite.host;
                    }
                    this.events = data.filter(x => x._id !== this.event._id);

                    if (!this.event.address || isNullOrUndefined(this.event.address.lat)) {
                        this.mapZoom = ConfigService.config.google.fullUSMapZoom;
                    }
                    if (this.event.description && this.event.description !== 'undefined') {
                        setTimeout(() => {
                            this.description.nativeElement.innerHTML = this.event.description;
                        });
                    } else {
                        setTimeout(() => {
                            this.description.nativeElement.innerHTML = '(no description)';
                        });
                    }
                    this.fitBounds();
                    this.isLoading = false;
                    this.loadingSpinner.hide();
                    // localStorage.setItem(localStorageKeys.visitorEvents, JSON.stringify(data.slice(0, 1000)));
                    VisitorDataCache.events = data;
                    if (!this.event) {
                        this.modalService.showErrorModal('Event id is wrong!');
                        this.gotoPlaceCalendar();
                        return;
                    }
                    this.setMeta();
                }
            });
            return;
        }

        if (this.event.socialName === config.eventbrite) {
            this.eventHost = constantConfigs.eventbrite.host;
        }
        this.events = allEventsWithCurrent.filter(x => x._id !== this.event._id);
        if (this.event.description && this.event.description !== 'undefined') {
            setTimeout(() => {
                this.description.nativeElement.innerHTML = this.event.description;
            });
        } else {
            setTimeout(() => {
                this.description.nativeElement.innerHTML = '(no description)';
            });
        }
        this.fitBounds();
        this.isLoading = false;
        this.loadingSpinner.hide();
        // this.getEvents().subscribe(data => {
        //     this.events = data;
        //     localStorage.setItem(localStorageKeys.visitorEvents, JSON.stringify(data.slice(0, 1000)));
        //     VisitorDataCache.events = data;
        // });
    }

    private fitBounds() {
        this.googleMapService.getGoogle().then(() => {
            this.latLngBounds = new google.maps.LatLngBounds();

            this.events.forEach(x => {
                if (x.address && x.address.lat && x.address.lng) {
                    this.latLngBounds.extend(new google.maps.LatLng(x.address.lat, x.address.lng));
                }
            });
        });
    }

    private setMeta() {
        let metaList = document.getElementsByTagName("meta");
        for (let i = 0; i < metaList.length; i++) {
            if (metaList[i].getAttribute("property") == "og:description") {
                metaList[i].content = this.event.description;
            }
            if (metaList[i].getAttribute("property") == "og:image") {
                metaList[i].content = this.imageService.imageSource(this.event);
            }
            if (metaList[i].getAttribute("property") == "og:title") {
                metaList[i].content = this.event.title || this.event.name;
            }
            if (metaList[i].getAttribute("property") == "og:url") {
                metaList[i].content = window.location.href;
            }
        }
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.details/visitor.event.details.component.ts